// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c053809","455":"b9c51074"}[chunkId] + ".chunk.js";
};